import type { Case } from 'types/case'
import type { ConditionalKeys } from 'types/editor'

export const getConditionalKeys = (caseDetails: Case) => {
  const conditionalKeys: ConditionalKeys[] = []

  const hasFinalRestingComponents =
    caseDetails.interment_place ||
    caseDetails.interment_address ||
    caseDetails.interment_city ||
    caseDetails.interment_state ||
    caseDetails.interment_postal_code

  if (hasFinalRestingComponents) {
    conditionalKeys.push('final_resting')
  }

  const shouldAddFirstLetterKey = (caseDetails: Case, fieldKey: keyof Case) => {
    return (
      caseDetails[fieldKey] &&
      typeof caseDetails[fieldKey] === 'string' &&
      caseDetails[fieldKey].trim() !== ''
    )
  }

  const hasFirstName = shouldAddFirstLetterKey(caseDetails, 'first_dec')
  const hasMiddleName = shouldAddFirstLetterKey(caseDetails, 'middle_dec')
  const hasLastName = shouldAddFirstLetterKey(caseDetails, 'lastdec')

  if (hasFirstName) {
    conditionalKeys.push('first_letter_first_dec')
  }

  if (hasMiddleName) {
    conditionalKeys.push('first_letter_middle_dec')
  }

  if (hasLastName) {
    conditionalKeys.push('first_letter_lastdec')
  }

  return conditionalKeys
}
